import React from "react";

export default function PlansContainerTopHeader({setYearlySelected, yearlySelected}) {
  return (
    <div className="row">
      <div className="col-sm-12">
        <div>
          <h2 className="plan_heading">Teedex Flexible Pricing Plans</h2>
          <p className="plan_text">
            Whether you’re a small team or a large organization, we have the
            perfect plan for you to streamline your custom jersey designs.
            Accelerate your jersey creation process with Teedex’s adaptable
            pricing options!
          </p>

          <div className="toggleBlock">
            <div className="toggleBlockList">
              <div
                className={`toggleBlockItem ${
                  yearlySelected === false ? "active" : ""
                }`}
                onClick={() => setYearlySelected(!yearlySelected)}
              >
                Monthly
              </div>
              <div
                className={`toggleBlockItem ${
                  yearlySelected === true ? "active" : ""
                }`}
                 onClick={() => setYearlySelected(!yearlySelected)}
              >
                Yearly
              </div>
              <div
                className={`toggleBlockItem-background ${
                  yearlySelected === false ? "monthly" : "yearly"
                }`}
              ></div>
            </div>
            <div className="toggleBlockInfo">2 Months Free</div>
          </div>
        </div>
      </div>
    </div>
  );
}
